import { Card } from '../services/card.model';
import GlobalSpinnerService from '../../common/services/spinner/global-spinner.service';
import { PaycellService } from '../services/paycell.service';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import {
  PaymentProgressChangeAction,
  PaymentProgressStatus
} from '../../components/payment-progress/payment-progress.action';

/* @ngInject */
export default class PaycellCardAddController {
  private card: Card;
  private sessionId: string;
  private token: string;
  private alias: string;

  constructor(
    private $state,
    private globalSpinner: GlobalSpinnerService,
    private paycellService: PaycellService,
    private actionDispatcher: ActionDispatcherService
  ) {}

  public $onInit() {
    this.sessionId = localStorage.getItem('cardSessionId');
    this.token = localStorage.getItem('cardToken');
    this.alias = localStorage.getItem('cardAlias');
    if (this.sessionId && this.token) {
      this.globalSpinner.start();
      localStorage.removeItem('cardSessionId');
      localStorage.removeItem('cardToken');
      localStorage.removeItem('cardAlias');
      this.paycellService
        .createPaymentMethod(
          this.sessionId,
          this.token,
          this.alias ? this.alias : ''
        )
        .then(data => {
          this.$state.go('payByCard');
        })
        .finally(() => this.globalSpinner.stop());
    }

    this.actionDispatcher.dispatch(
      new PaymentProgressChangeAction(PaymentProgressStatus.PAY)
    );
  }

  public onAddCard() {
    this.globalSpinner.start();
    this.paycellService.paymentHashData()
    .then(data => {
      this.paycellService
      .paymentRestToken(this.card, data)
      .then(data => {
        let token = data.cardToken;
        this.paycellService
          .get3DSessionID(token == null ? '' : token, '')
          .then(data => {
            let sessionId = data;
            this.paycellService.get3DSessionResult(sessionId).then(data => {
              const redirectUrl = window.location.href;
              this.paycellService
                .threeDSecure(sessionId, encodeURIComponent(redirectUrl))
                .then(data => {
                  localStorage.setItem('cardToken', token);
                  localStorage.setItem('cardSessionId', sessionId);
                  if (this.card.alias)
                    localStorage.setItem('cardAlias', this.card.alias);
                  document.open();
                  document.write(data);
                  document.close();
                });
            });
          });
      })
      .finally(() => this.globalSpinner.stop());
    }).catch(() => this.globalSpinner.stop());
    
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/paycell-card-add/paycell-card-add.controller.ts